// extracted by mini-css-extract-plugin
export default {"svg":"ImageStepFirst_svg__eUwvI"};